export default {
      id: "color_ancestry_gray-usage",
      viewBox: "0 0 49 70",
      url: __webpack_public_path__ + "sprite.svg#color_ancestry_gray",
      toString: function () {
        return this.url;
      }
    }